import { useCallback, useRef } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { List, RowComponentProps } from 'react-window';

import { UploadProps } from '../../../types';
import Row from './Row';

const DEFAULT_ROW_HEIGHT = 60;

const RowRender = ({ index, style, files, onRemove, setSize }: RowComponentProps<{
  files: File[],
  onRemove?: (file: File) => void,
  setSize: (index: number, size: number) => void;
}>) => (
  <Row style={style} file={files[index]} index={index} onRemove={onRemove} setSize={setSize} />
);

export default function PreviewMultiFile({ files, onRemove }: UploadProps) {
  const listRef = useRef(null);
  const sizeMap = useRef<Record<number, number>>({});

  const setSize = useCallback((index: number, size: number) => {
    sizeMap.current = { ...sizeMap.current, [index]: size };
  }, []);

  const getSize = (index: number) => sizeMap.current[index] || DEFAULT_ROW_HEIGHT;

  if (!files?.length) return null;

  return (
    <AutoSizer disableWidth>
      {({ height }) => {
      return (
        <List
          rowCount={files.length}
          rowHeight={getSize}
          className="customScrollBar"
          listRef={listRef}
          style={{ height, maxHeight: 'inherit' }}
          rowProps={{
            files,
            onRemove,
            setSize,
          }}
          rowComponent={RowRender}
        />
      )}}
    </AutoSizer>
  );
}
